import { BaseRepository } from "./BaseRepository";

export class FirmsRepository extends BaseRepository {
  async getAllFirms() {
    const cachedData = this.getCached("all-firms");
    if (cachedData) {
      return cachedData;
    }

    const response = await this.get("/firm");
    const data = response.data || [];

    this.setCached("all-firms", data);
    return data;
  }

  async assignUserToFirm(firmId, userId, role) {
    await this.post(`/firm/${firmId}/user`, { user_id: userId, role });
    this.cache.clear();
  }

  async createFirm(firmName) {
    const response = await this.post("/firm", { firm_name: firmName });
    this.cache.clear();
    return response.data.firm_id;
  }
}
